import React from 'react';
import { CheckerBackdrop } from 'src/shared/components/CheckerBackdrop';
import { DisplayHeading } from 'web-common/src/shared/design-system/components/DisplayHeading';

/** Animation left as a slot so Suspense fallbacks can render this without pulling in lottie. */
export const IntakeLoadingFrame: React.FC<
  React.PropsWithChildren<{ headline?: React.ReactNode; animation?: React.ReactNode }>
> = ({ headline = 'stirring up nearby shefs...', animation, children }) => (
  <div className='relative flex min-h-[calc(100svh-48px)] flex-col items-center overflow-hidden bg-white'>
    <div className='z-[1] mt-12 size-[150px] md:size-[262px]'>{animation}</div>
    <DisplayHeading className='z-[1] mt-4 max-w-[316px] md:max-w-[488px]'>{headline}</DisplayHeading>
    {children}
    <CheckerBackdrop topClassName='top-[45svh]' />
  </div>
);
